module.exports = __webpack_public_path__ + "static/media/lottery-game.986fd982.svg";